"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getDepositBalance = getDepositBalance;
exports.getPaymentOptions = getPaymentOptions;
exports.getPrimaryGuest = getPrimaryGuest;
var _moment = _interopRequireDefault(require("moment"));
function getDepositBalance(folio) {
  var bookingStatus = folio.bookingStatus;
  var depositBalance = bookingStatus === 'depositDue' ? ((folio === null || folio === void 0 ? void 0 : folio.depositTotal) || 0) - ((folio === null || folio === void 0 ? void 0 : folio.paymentTotal) || 0) : 0;
  return parseInt(Math.max(depositBalance, 0), 10);
}
function getPaymentOptions(folio, defaultAmount, formatMessage) {
  var bookingStatus = folio.bookingStatus,
    paymentTotal = folio.paymentTotal,
    depositDeadline = folio.depositDeadline,
    accomTotal = folio.accomTotal,
    balanceDeadline = folio.balanceDeadline,
    outstandingTotal = folio.outstandingTotal;
  var paymentOptions = [];
  var depositBalance = getDepositBalance(folio);
  var accomBalance = accomTotal - paymentTotal;
  var hasDefaultAmount = typeof defaultAmount === 'number';
  if (bookingStatus === 'depositDue') {
    var depositDueOption = {
      name: 'deposit',
      label: formatMessage({
        id: 'htmPayment.field.depositDue'
      }),
      subLabel: formatMessage({
        id: 'htmPayment.general.dueDate'
      }, {
        date: (0, _moment["default"])(depositDeadline).format('ll')
      }),
      isDefault: !hasDefaultAmount,
      amount: depositBalance
    };
    paymentOptions.push(depositDueOption);
  }
  if ((bookingStatus === 'balanceDue' || bookingStatus === 'cancelled') && outstandingTotal !== accomBalance) {
    var balanceTotalOption = {
      name: 'balanceTotal',
      label: formatMessage({
        id: 'htmPayment.field.accomDue'
      }),
      subLabel: formatMessage({
        id: 'htmPayment.general.dueDate'
      }, {
        date: (0, _moment["default"])(balanceDeadline).format('ll')
      }),
      amount: accomBalance
    };
    paymentOptions.push(balanceTotalOption);
  }
  if (outstandingTotal > 0 && (bookingStatus !== 'depositDue' || depositBalance !== outstandingTotal)) {
    var outstandingOption = {
      name: 'outstanding',
      label: formatMessage({
        id: 'htmPayment.field.outstandingDue'
      }),
      amount: outstandingTotal,
      isDefault: !hasDefaultAmount && bookingStatus !== 'depositDue'
    };
    paymentOptions.push(outstandingOption);
  }
  var defaultOption = {
    name: 'specifyAmount',
    label: formatMessage({
      id: 'htmPayment.field.amountInput'
    }),
    isInput: true,
    isDefault: hasDefaultAmount || paymentOptions.length === 0,
    defaultValue: defaultAmount
  };
  return paymentOptions.push(defaultOption), paymentOptions;
}
function getPrimaryGuest(folio) {
  var folioGuests = Array.isArray(folio === null || folio === void 0 ? void 0 : folio.guests) ? folio === null || folio === void 0 ? void 0 : folio.guests : [];
  return folioGuests.find(function (g) {
    return g.primaryGuest === true;
  }) || folioGuests[0] || {};
}